<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <div class="leftSection">
            <div
              class="header-title wrapper-content__main font-size__large font-weight__bold"
            >
              Văn bản đã tiếp nhận
            </div>
          </div>
        </template>
      </headerTemplate>
    </template>
    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <subHeader>
              <template #content>
                <div class="leftSection margin-left-10">
                  <!--                hoang xuất kêt quả tìm kiếm -->
                  <el-tooltip class="item" effect="dark" content="Kết xuất kết quả tìm kiếm" placement="top-end">
                    <el-button
                      size="medium"
                      @click="chosenFileType"
                      type="primary">
                      <div class="flex-row flex__center">
                        <i class="fas fa-file-export"></i>
                        <span>&nbsp;KẾT XUẤT</span>
                      </div>
                    </el-button>
                  </el-tooltip>
                </div>
                <searchTemplate
                  :keyword="keyword"
                  @simpleSearch="simpleSearch"
                  @search="isOpenAdvanceSearchDialog = true"
                >
                  <template #quickFilter>
                    <div v-if="setVbStar" class="flex-row margin-right-40">
                      <span class="style-fullWidth label-input margin-right-10 no_wrap">Quan trọng: </span>
                      <input
                        style="display: none"
                        type="checkbox"
                        ref="starCheckbox"
                        v-model="isStar"
                      >
                      <div class="theTitle__star" @click="isStarChange">
                        <i :class="{'fas fa-star' : isStar, 'fal fa-star' : !isStar}" />
                      </div>
                    </div>
<!--                    <div-->
<!--                      class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large"-->
<!--                    >-->
<!--                      <span class="label-input width__auto">Ngày đến</span>-->
<!--                      <el-date-picker-->
<!--                        v-model="incomingDateRange"-->
<!--                        type="daterange"-->
<!--                        format="dd/MM/yyyy"-->
<!--                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"-->
<!--                        :picker-options="dateQuickFilterOption"-->
<!--                        range-separator="_"-->
<!--                        start-placeholder="_"-->
<!--                        end-placeholder="_"-->
<!--                        align="right"-->
<!--                        :clearable="false"-->
<!--                        @change="filterByIncomingDateRange"-->
<!--                      ></el-date-picker>-->
<!--                    </div>-->

                    <div class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large">
                      <span class="label-input width__auto"
                      >Ngày đến
                      </span>
                      <span class="label-input width__auto">Từ ngày:</span>
                      <el-date-picker
                        v-model="fromIncomingDate"
                        type="date"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        placeholder="Chọn ngày bắt đầu"
                        align="right"
                        :clearable="false"
                        @change="filterByIncomingDateRange"
                      ></el-date-picker>
                    </div>

                    <div class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large">
                      <span class="label-input width__auto">Đến ngày:</span>
                      <el-date-picker
                        v-model="toIncomingDate"
                        type="date"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        placeholder="Chọn ngày kết thúc"
                        align="right"
                        :clearable="false"
                        @change="filterByIncomingDateRange"
                      ></el-date-picker>
                    </div>
                  </template>
                  <template #advance>
                    <chotiepnhan-advance-search-dialog
                      :isOpen="isOpenAdvanceSearchDialog"
                      :form="advanceSearchForm"
                      :isEnableSearchTdhvpDoc="true"
                      :isEnableSearchLockedRole="true"
                      v-if="isEnableAdvanceSearchDialog"
                      @dialogClosed="isEnableAdvanceSearchDialog = false"
                      @closeDialog="isOpenAdvanceSearchDialog = false"
                      @doSearch="advanceSearch"
                      @searchTdhvpDoc="searchTdhvpDoc"
                      @searchLockedRoleDocIn="searchLockedRoleDocIn"
                    />
                  </template>
                </searchTemplate>
              </template>
            </subHeader>
          </template>

          <template #body>
            <div class="list">
              <!-- header-title -->
              <div class="header-title flex-row flex__between margin-bottom-10">
                <div class="leftSection flex-row flex__left">
                  <div class="theTitle theTitle__lv5" :class="{'theTitle--hasStar': setVbStar}">
                    <span class="stt margin-left-10">STT</span>
                  </div>
                  <div
                    class="theTitle theTitle__lv1 flex-row flex__left clickable"
                    @click="doSort('quote')"
                  >
                    Trích yếu
                    <sort-caret :order="order" :sort="sort" :field="'quote'"/>
                  </div>
                </div>
                <div class="rightSection flex-row flex__right">
                  <!--                  <div-->
                  <!--                    class="theTitle theTitle__lv2 flex-row flex__left padding-left-10 clickable"-->
                  <!--                    @click="doSort('forwardDeptName')"-->
                  <!--                  >-->
                  <!--                    Nơi gửi-->
                  <!--                    <sort-caret-->
                  <!--                      :order="order"-->
                  <!--                      :sort="sort"-->
                  <!--                      :field="'forwardDeptName'"-->
                  <!--                    />-->
                  <!--                  </div>-->
                  <div
                    class="theTitle theTitle__lv2 flex-row flex__left padding-left-10 clickable"
                    @click="doSort('publisherName')"
                  >
                    Đơn vị phát hành
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'publisherName'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__right padding-right-10 clickable"
                    @click="doSort('docDate')"
                  >
                    Ngày văn bản
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'docDate'"
                    />
                  </div>

                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left clickable"
                    @click="doSort('incomingDate')"
                  >
                    Ngày đến
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'incomingDate'"
                    />
                  </div>

                  <div
                    class="theTitle theTitle__lv3 flex-row flex__right padding-right-10 clickable"
                    @click="doSort('vbDocInBookUpdateTime')"
                  >
                    Ngày vào sổ
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'vbDocInBookUpdateTime'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__right padding-right-10 clickable"
                    @click="doSort('vbDocInBookBookName')"
                  >
                    Sổ văn bản - Số
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'vbDocInBookBookName'"
                    />
                  </div>
                </div>
              </div>
              <!-- list-docs -->
              <VuePerfectScrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <div
                    v-for="(item, $itemIndex) in incomingDocs"
                    v-bind:key="$itemIndex"
                    class="item flex-row flex__between"
                    @click="viewDetail(item)"
                  >
                    <div class="leftSection flex-row flex__left">
                      <div :class="{'theTitle--hasStar': setVbStar, 'theTitle__lv5': !setVbStar}">
                        <div class="flex-row" :class="{'flex__between': setVbStar, 'flex__left': !setVbStar}">
                          <div class="section-check">
                            <span class="stt flex-row flex__center">{{
                              $itemIndex + 1
                            }}</span>
                          </div>
                          <img
                            class="icon-small clickable"
                            src="../../assets/img/symbol/file.svg"
                            alt=""
                            @click.stop="
                              downloadAttachment(
                                item,
                                ATTACHMENT_OBJECT_TYPE.VB_DEN
                              )
                            "
                          />
                          <div class="theTitle__star" v-if="setVbStar">
                            <i
                              :class="{'fal fa-star': !item.isStar, 'fas fa-star': item.isStar}"
                              @click.stop="changeStar(item)"
                            ></i>
                          </div>
                        </div>
                      </div>
                      <div class="theTitle__lv1 margin-right-10" :class="{'margin-left-10': setVbStar}">
                        <div class="title-docs flex-col flex__left">
                          <div
                            class="tt_1 clickable"
                            v-bind:class="textBold(item)"
                          >
                            {{ item.quote }}
                          </div>
                          <div class="tt_2 flex-row flex__left margin-top-10">
                            <span v-if="item.docCode"
                            >{{ item.docCode }}&nbsp;&nbsp;</span
                            >
                            <el-tag
                              v-if="item.docTypeName"
                              size="mini"
                              :class="['priority', 'lv3']"
                            >{{ item.docTypeName }}
                            </el-tag>
                            <el-tag
                              v-if="isShowPriority(item.priorityId)"
                              size="mini"
                              :class="[
                                'priority',
                                getPiorityClass(item.priorityId)
                              ]"
                            >
                              <img
                                src="@/assets/img/new-symbol/zap.svg"
                                alt=""
                                class="icon-very__small"
                              />
                              <span>
                                {{ item.priorityName }}
                              </span>
                            </el-tag>
                            <span>
                               <el-tooltip
                                 content="Văn bản điện tử"
                                 placement="top"
                                 effect="dark"
                                 v-if="isVbDienTu(item)"
                               >
                                 <div class="eIcon">e</div>
                               </el-tooltip>
                            </span>
                            <span>
                               <el-tooltip
                                 content="Đã ban hành bản giấy"
                                 placement="top"
                                 effect="dark"
                                 v-if="item.isBanHanhBanGiay"
                               >
                                 <div class="eIcon">p</div>
                               </el-tooltip>
                            </span>
                            <span>
                               <el-tooltip
                                 content="Không có tài liệu đính kèm"
                                 placement="top"
                                 effect="dark"
                                 v-if="item.isNotFileDinhKem"
                               >
                                 <div class="eIcon">p</div>
                               </el-tooltip>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightSection flex-row flex__right">
                      <!--                      <div-->
                      <!--                        class="theTitle__lv2 flex-row flex__left padding-left-10 font-size__small"-->
                      <!--                      >-->
                      <!--                        <div class="flex-row flex__right txt-left">-->
                      <!--                          {{-->
                      <!--                          item.forwardDeptName || item.publisherName || "-"-->
                      <!--                          }}-->
                      <!--                        </div>-->
                      <!--                      </div>-->
                      <div
                        class="theTitle__lv2 flex-row flex__left padding-left-10 font-size__small"
                      >
                        <div class="flex-row flex__right txt-left">
                          {{
                            (item.publisherNameDetail ? item.publisherNameDetail + " " : "") +
                            (
                              item.forwardDeptName ||
                              item.publisherName ||
                              item.outsidePublisherName ||
                              item.insidePublisherName
                            ) ||
                            "-"
                          }}
                        </div>
                      </div>

                      <div
                        class="theTitle__lv3 flex-row flex__right padding-right-10 font-size__small"
                      >
                        <div class="flex-row flex__right txt-right">
                          {{
                          item.docDate
                          | dateFormatter({
                          nullValue: "-",
                          dateFormat: "DD/MM/YYYY"
                          })
                          }}
                        </div>
                      </div>

                      <div
                        class="theTitle__lv3 flex-row flex__left font-size__small"
                      >
                        <div class="flex-row flex__right txt-left">
                          <i class="cellIcon color__silver fas fa-clock"></i>
                          {{
                          item.incomingDate | dateFormatter({ nullValue: "-" })
                          }}
                        </div>
                      </div>

                      <div
                        class="theTitle__lv3 flex-row flex__right padding-right-10 font-size__small"
                      >
                        <div class="flex-row flex__right txt-right">
                          {{
                          item.vbDocInBookUpdateTime
                          | dateFormatter({
                          nullValue: "-",
                          dateFormat: "DD/MM/YYYY"
                          })
                          }}
                        </div>
                      </div>

                      <div
                        class="theTitle__lv3 flex-row flex__right padding-right-10 font-size__small"
                      >

                        <div class="flex-row flex__right txt-left">
                          {{ item.vbDocInBookBookName }} - {{ item.bookNumber }}
                        </div>
                      </div>

                       <div class="theQuickAction flex-row flex__right">
                         <el-tooltip content="In phiếu xử lý" placement="top">
                           <i
                             @click.stop="inPhieuTrinhKi(item)"
                             class="action-icon bgAmbient__green clickable fas fa-print"
                           ></i>
                         </el-tooltip>
                       </div>
                      <!--                        <div class="flex-row flex__right txt-left">-->
                      <!--                          {{getStatus(item) || '-'}}-->
                      <!--                        </div>-->
                      <!--                      </div>-->

                      <!--                      <div class="theQuickAction flex-row flex__right">-->
                      <!--                        <el-tooltip-->
                      <!--                          content="Sao chép"-->
                      <!--                          placement="top"-->
                      <!--                        >-->
                      <!--                          <img-->
                      <!--                            @click.stop="copyDoc(item)"-->
                      <!--                            src="@/assets/img/new-symbol/edit.svg"-->
                      <!--                            alt-->
                      <!--                            class="action-icon clickable border-radius__50"-->
                      <!--                          >-->
                      <!--                        </el-tooltip>-->
                    </div>
                  </div>

                  <infinite-loading
                    ref="infiniteLoading"
                    spinner="spiral"
                    @infinite="infiniteHandler"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results">Không có dữ liệu</div>
                  </infinite-loading>
                </div>
              </VuePerfectScrollbar>
            </div>
          </template>
        </listTemplate>
      </div>
      <!--      hoang chosen file type-->
      <chosen-file-type-dialog
        v-if="isOpenChosenFileTypeDialog"
        @closeDialog="isOpenChosenFileTypeDialog= false"
        @exportResult="exportResult"
        :is-open="true">
      </chosen-file-type-dialog>

      <createDialog
        :isOpen="isOpenDialogCreate"
        :id="selectedDocId"
        v-if="isEnableDialogCreate"
        @dialogClosed="isEnableDialogCreate = false"
        @closeDialog="closeDialog"
        @success="createDocSuccess"
      />
    </template>
  </listTemplate>
</template>
<script>
  import InfiniteLoading from "vue-infinite-loading";
  import vbIncomingDocInBookViewService from "../../services/vbIncomingDocInBookViewService";
  import dateFormatter from "../../filters/dateFormatter";
  import constants from "../../constants";
  import utils from "../../services/utils";
  import BreakWordSpan from "../adminstration/ketluan/break-word-span";
  import listTemplate from "../common/list";
  import headerTemplate from "../../components/header/main-header.vue";
  import searchTemplate from "../common/search";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
  import {EventBus} from "../../event-bus.js";
  import ChotiepnhanAdvanceSearchDialog from "./components/chotiepnhan-advance-search-dialog";
  import vbDenVTMixin from "./vbDenVTMixin";
  import h from "../../services/h";
  import chosenFileTypeDialog from "../doc-out/chosenFileTypeDialog";
  import vbDocUserService from "../../services/vbDocUserService";

  export default {
    name: "vb-den-vt-index",
    mixins: [vbAttachmentTokenMixin, vbDenVTMixin],
    props: ["statusByVT", "setVbStar"],
    components: {
      chosenFileTypeDialog,
      BreakWordSpan,
      ChotiepnhanAdvanceSearchDialog,
      InfiniteLoading,
      listTemplate,
      headerTemplate,
      searchTemplate,
      VuePerfectScrollbar,
      subHeader: () => import("../../components/main/sub-header.vue"),
      createDialog: () => import("./components/CreateDialog.vue"),
      SortCaret: () => import("../doc-out/SortCaret")
    },

    filters: {dateFormatter},

    data() {
      return {
        isOpenChosenFileTypeDialog:false,
        sortList:[],
        ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE,
        dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),

        isOpenAdvanceSearchDialog: false,
        isEnableAdvanceSearchDialog: false,
        isOpenDialogCreate: false,
        isEnableDialogCreate: false,
        perfectScrollbarSetting: {maxScrollbarLength: 350},

        incomingDocs: [],
        incomingDocsCount: null,

        selectedDocId: null,

        page: 0,
        size: 10,
        sort: null,
        order: null,
        keyword: null,
        incomingDateRange: null,
        isStar: false
      };
    },

    computed: {
      userDeptRoleId() {
        return this.$route.params.userDeptRoleId;
      },
      parentRoute() {
        return this.$route.path.split("/")[3];
      },
    },

    watch: {
      isOpenDialogCreate(newValue) {
        newValue && (this.isEnableDialogCreate = newValue);
      },
      isOpenAdvanceSearchDialog(newValue) {
        newValue && (this.isEnableAdvanceSearchDialog = newValue);
      },
      isEnableDialogCreate(newValue) {
        if (!newValue) {
          this.selectedDocId = null;
          this.copyFromDocId = null;
        }
      },
    },

    created() {
      this.initQuery();
      this.setDefaultDocDateRange();
      this.filterByIncomingDateRange();
    },

    mounted() {
      EventBus.$on(this.parentRoute, () => {
        this.doSearch();
      });
    },

    methods: {
      searchTdhvpDoc() {
        this.$router.push({
          name: "tdhvpDocInVtIndex",
          params: this.$route.params
        });
      },
      isVbDienTu(item){
        if(item.vbOutgoingDocId!=null){
          return true;
        }else {
          return false;
        }

      },
      inPhieuTrinhKi(item) {
        let baseServiceURL = constants.BASE_SERVICE_URL;
        let reportUrl = constants.IN_PHIEU.VB_DEN;
        window.open(
          `${baseServiceURL}${reportUrl}?${utils.serialize({docId: item.id})}`,
        );
      },
      chosenFileType(){
        this.isOpenChosenFileTypeDialog = true
      },
      exportResult(item) {
        this.isOpenChosenFileTypeDialog = false
        this.exportSearchResult(item,'VAN_BAN_DA_TIEP_NHAN')
      },

      textBold(event) {
        if (event.hasOwnProperty("isRead")) {
          if (event.isRead === "seen") return "";
          else return "text-bold";
        } else return "";
      },

      setDefaultDocDateRange() {
        const startDate = new Date(new Date().getFullYear(), 0, 1);
        this.fromIncomingDate = startDate;
      },

      filterByIncomingDateRange(event) {
        const a = this.isValidDate(this.fromIncomingDate);
        const b = this.isValidDate(this.toIncomingDate);

        if ((this.fromIncomingDate === null || !a) && (this.toIncomingDate === null || b)) {
          this.fromIncomingDate = new Date(new Date().getFullYear(), 0, 1);
        } else if ((this.toIncomingDate === null || !b) && (this.fromIncomingDate === null || a)) {
          this.toIncomingDate = new Date(new Date().getFullYear(), 11, 31);
        } else if (this.fromIncomingDate > this.toIncomingDate) {
          this.fromIncomingDate = new Date(new Date().getFullYear(), 0, 1);
          this.toIncomingDate = new Date(new Date().getFullYear(), 11, 31);
        }

        this.advanceSearchForm.fromIncomingDate = this.fromIncomingDate ? this.fromIncomingDate.getTime() : undefined;
        this.advanceSearchForm.toIncomingDate = this.toIncomingDate ? this.toIncomingDate.getTime() : undefined;
        this.doSearch();
      },

      isValidDate(date) {
        return date instanceof Date && !isNaN(date);
      },

      getStatus(item) {
        let checkChuaVaoSo =
          item.status === constants.INCOMING_DOC_STATUS.TAO_MOI
            ? "Chưa vào sổ"
            : "";
        let checkStatus =
          item.status === constants.INCOMING_DOC_STATUS.TU_CHOI ? "Từ chối" : "";
        return `${checkChuaVaoSo} ${checkStatus}`;
      },

      closeDialog() {
        this.isOpenDialogCreate = false;
      },

      isShowPriority(id) {
        return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) !== -1;
      },

      createDocSuccess() {
        this.isOpenDialogCreate = false;
        this.doSearch();
      },

      initQuery() {
        this.sort = this.$route.query.sort || "incomingDate";
        this.order = this.$route.query.order || "desc";
        this.advanceSearchForm = {
          keyword: this.$route.query.keyword || undefined,
          fromDocDate: this.$route.query.fromDocDate
            ? parseInt(this.$route.query.fromDocDate)
            : undefined,
          toDocDate: this.$route.query.toDocDate
            ? parseInt(this.$route.query.toDocDate)
            : undefined,
          fromIncomingDate: this.$route.query.fromIncomingDate
            ? parseInt(this.$route.query.fromIncomingDate)
            : undefined,
          toIncomingDate: this.$route.query.toIncomingDate
            ? parseInt(this.$route.query.toIncomingDate)
            : undefined,
          docCode: this.$route.query.docCode || undefined,
          quote: this.$route.query.quote || undefined,
          fileContent: this.$route.query.fileContent || undefined,
          docTypeId: this.$route.query.docTypeId || undefined,
          bookId: this.$route.query.bookId || undefined,
          publisherId: this.$route.query.publisherId || undefined,
          outsidePublisherName:
            this.$route.query.outsidePublisherName || undefined,
          insidePublisherName:
            this.$route.query.insidePublisherName || undefined,
          isStar: this.$route.query.isStar === '1' ? 1 : 0
        };
        this.keyword = this.advanceSearchForm.keyword;
        this.isStar = !!+this.$route.query.isStar;
        this.initIncomingDateRange();
      },

      buildQuery() {
        return utils.merge(
          {sort: this.sort || "incomingDate", order: this.order || "desc"},
          this.advanceSearchForm
        );
      },

      simpleSearch(keyword) {
        this.keyword = this.advanceSearchForm.keyword = keyword;
        this.advanceSearchForm.docCode = undefined;
        this.advanceSearchForm.quote = undefined;
        this.advanceSearchForm.fileContent = undefined;
        this.advanceSearchForm.docTypeId = undefined;
        this.advanceSearchForm.bookId = undefined;
        this.advanceSearchForm.publisherId = undefined;
        this.advanceSearchForm.outsidePublisherName = undefined;
        this.advanceSearchForm.insidePublisherName = undefined;
        this.doSearch();
      },

      advanceSearch(event) {
        let advanceSearchForm = event.advanceSearchForm;
        this.sortList=event.sortList;
        this.advanceSearchForm.keyword = undefined;
        this.keyword = null;
        this.advanceSearchForm.docCode = advanceSearchForm.docCode || undefined;
        this.advanceSearchForm.quote = advanceSearchForm.quote || undefined;
        this.advanceSearchForm.fileContent =
          advanceSearchForm.fileContent || undefined;
        this.advanceSearchForm.docTypeId =
          advanceSearchForm.docTypeId || undefined;
        this.advanceSearchForm.bookId = advanceSearchForm.bookId || undefined;
        this.advanceSearchForm.publisherId =
          advanceSearchForm.publisherId || undefined;
        this.advanceSearchForm.priorityId =
          advanceSearchForm.priorityId || undefined;
        this.advanceSearchForm.outsidePublisherName =
          advanceSearchForm.outsidePublisherName || undefined;
        this.advanceSearchForm.insidePublisherName =
          advanceSearchForm.insidePublisherName || undefined;
        this.advanceSearchForm.toIncomingDate =
          advanceSearchForm.toIncomingDate || undefined;
        this.advanceSearchForm.fromIncomingDate =
          advanceSearchForm.fromIncomingDate || undefined;
        this.advanceSearchForm.fromDocDate =
          advanceSearchForm.fromDocDate || undefined;
        this.advanceSearchForm.toDocDate =
          advanceSearchForm.toDocDate || undefined;
        this.advanceSearchForm.sortList =
          event.sortList || undefined;
        this.initIncomingDateRange();
        this.doSearch();
      },

      doSort(sort) {
        this.sort = sort;
        this.order =
          sort === this.sort ? (this.order === "asc" ? "desc" : "asc") : "asc";
        this.doSearch();
      },

      doSearch() {
        this.$router.replace({
          name: this.$router.name,
          params: this.$route.params,
          query: this.buildQuery()
        });
        this.incomingDocs = [];
        this.page = 0;
        this.$nextTick(
          () =>
            this.$refs.infiniteLoading &&
            this.$refs.infiniteLoading.stateChanger.reset()
        );
      },

      infiniteHandler($state) {
        this.list().then(items => {
          this.page += 1;
          items && items.length ? $state.loaded() : $state.complete();
        });
      },

      async list() {
        let pageable;
        if(this.sortList&&this.sortList.length>0){

          let sort=[];
          h.each(this.sortList,(item)=>{
            sort.push(item);
          })
          pageable = {
            page: this.page,
            size: this.size,
            sort: sort
          };
        }else {
          pageable = {
            page: this.page,
            size: this.size,
            sort: [this.sort, this.order].join(",")
          };
        }

        let advanceSearchForm = utils.merge(this.advanceSearchForm, {
          statusByVT: this.statusByVT
        });

        let items = [];

        await vbIncomingDocInBookViewService
          .findAll2(advanceSearchForm, pageable)
          .then(response => {
            items = response.data;
          });
        await vbDocUserService.getAllVbIsStarByUserDeptRole(this.userDeptRoleId)
          .then(response => {
            const vbDocIdsIsStarMap = response.data;

            for(let i = 0; i < items.length; i++) {
              items[i].isStar = 0;
              for(let key in vbDocIdsIsStarMap) {
                if (key === items[i].id) {
                  items[i].isStar = vbDocIdsIsStarMap[key]
                }
              }
            }

            this.incomingDocs.push(...items);
          })
        return items;
      },

      exportSearchResult(fileType,name) {
        let pageable;
        if(this.sortList&&this.sortList.length>0){
          let sort=[];
          h.each(this.sortList,(item)=>{
            sort.push(item);
          })
          pageable = {
            page: 0,
            size: 1000,
            sort: sort
          };
        }else {
          pageable = {
            page: 0,
            size: 1000,
            sort: [this.sort, this.order].join(",")
          };
        }

        let param = utils.merge(this.advanceSearchForm, {
          statusByVT: this.statusByVT
        });

        let params = utils.merge(param, pageable)
        console.log('userDeptRole',this.$store.getters.userDeptRole)
        params.userId=this.$store.getters.userDeptRole.userId;
        params.deptId=this.$store.getters.userDeptRole.deptId;
        params.roleId=this.$store.getters.userDeptRole.roleId;
        params.positionId = this.$store.getters.userDeptRole.positionId;
        params.fileType = fileType
        params.name = name
        let baseServiceURL = constants.BASE_SERVICE_URL;
        let reportUrl = constants.IN_PHIEU.SEARCH_RESULT_VT_DA_TIEP_NHAN;
        window.open(
          `${baseServiceURL}${reportUrl}?${utils.serialize(params)}`
        );


        // return vbIncomingDocInBookViewService
        //   .findAll2(advanceSearchForm, pageable)
        //   .then(response => {
        //     let items = response.data;
        //     items && this.incomingDocs.push(...items);
        //     return items;
        //   });
      },

      viewDetail(item) {
        item.isRead = "seen";
        this.selectedDocId = item.id;
        this.$emit("viewDetail", {doc: item});
        // this.$router.push({
        //   name: "vbDenDaTiepNhanDetail",
        //   params: {id: item.id},
        //   query: this.$route.query
        // });
      },

      getPiorityClass(id) {
        return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) !== -1
          ? "lv1"
          : "lv4";
      },

      changeStar(item) {
        const isStar = item.isStar === 1 ? 0 : 1

        vbDocUserService.setStar({
          vbDocId: item.id,
          userDeptRoleId: this.userDeptRoleId,
          isStar: isStar
        })
          .then(() => {
            item.isStar = isStar

            // Nếu đang filter theo văn bản có dấu sao thì sẽ reload trang nếu có thay đổi dấu sao của 1 văn bản
            if(this.isStar) {
              this.doSearch();
            }
          })
          .catch(() => {
            console.log('Không thể đánh dấu sao cho văn bản!')
          })
      },

      isStarChange(value) {
        this.$refs.starCheckbox.click();
        const isStar = this.$refs.starCheckbox.checked ? 1 : 0;
        this.advanceSearchForm.isStar = isStar;
        this.doSearch();
      },

      searchLockedRoleDocIn() {
        this.$router.push({
          name: "lockedRoleDocInIndex",
          params: this.params
        });
      }
    }
  };
</script>
<style scoped>
  #searchBox {
    position: relative;
    width: 100%;
  }

  .advance-search {
    font-size: 17px;
    color: #005eb1;
    position: absolute;
    right: 5%;
    top: 50%;
    transform: translateY(-50%);
  }

  .icon-very__small {
    height: 14px;
    padding-top: 4px;
  }

  .icon-info {
    background-color: #f0c330;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    margin-top: -1px;
    margin-left: 2px;
  }
  .eIcon{
    border: solid 1px #007aff;
    border-radius: 2px;
    padding: 0px 3px;
    font-size: 11px;
    color: goldenrod;
    margin-left:2px;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-in/vbDenVTIndex.vue